/**
 * Llamadas HTTP del dominio Dashboard.
 *
 * SIEMPRE sobre el cliente único `lib/api` (`docs/frontend_architecture.md`,
 * Pr. 2): ningún `fetch`/`ky` suelto. El cliente ya aporta `credentials:
 * 'include'`, el `X-CSRF-TOKEN` y el `X-Sede-Id` (sede activa) en cada request,
 * así que estos KPIs se calculan para la sede activa sin que la feature toque la
 * cabecera a mano.
 *
 * Los endpoints son **read-only**: el backend ya devuelve dicts JSON-safe con una
 * lista blanca de claves (ver `domains/core.py` y `domains/stats.py`); aquí solo
 * se tipa la respuesta. Un `ApiError` (401/403/5xx) lo propaga el cliente y lo
 * gestionan los hooks/pantalla.
 */
import { api } from "@/lib/api";

import type { DashboardStats, EffectivenessStats } from "./types";

/**
 * KPIs del dashboard de la sede activa (`GET /api/v1/core/dashboard`).
 *
 * Login-only en el backend (solo exige JWT válido): lo pueden pedir todos los
 * usuarios autenticados, igual que el dashboard del SSR.
 */
export async function fetchDashboardStats(): Promise<DashboardStats> {
  const response = await api.get("core/dashboard");
  return (await response.json()) as DashboardStats;
}

/**
 * Efectividad de entregas de la sede activa (`GET /api/v1/stats/effectiveness`).
 *
 * Métrica avanzada: el hook que la consume se habilita solo con el permiso
 * `advanced_stats` (paridad con el menú "Análisis" del SSR), de modo que no se
 * pide para quien no debe verla.
 */
export async function fetchEffectiveness(): Promise<EffectivenessStats> {
  const response = await api.get("stats/effectiveness");
  return (await response.json()) as EffectivenessStats;
}
